import React, { Component } from "react";

import positive from "./img/p-plus-4.svg";
import negative from "./img/p-minus-2.svg";

import styles from "./style.module.scss";
import { injectIntl, FormattedMessage } from "react-intl";

class Ideal extends Component {
  render() {
    const { intl, component_strings } = this.props;
    return (
      <div className={styles.results}>
        <div className={styles.results__ideal}>
          <h4>
            <FormattedMessage
              id={component_strings.heading}
              defaultMessage={component_strings.heading}
              description=""
            />
          </h4>
          <div className={styles.results__ideal__result}>
            <p>
              <FormattedMessage
                id={component_strings.description1}
                defaultMessage={component_strings.description1}
                description=""
              />
            </p>
            <img
              draggable="false"
              src={positive}
              alt={intl.formatMessage({
                id: component_strings.alt1,
                defaultMessage: component_strings.alt1,
                description: "",
              })}
            />
            <img
              draggable="false"
              src={negative}
              alt={intl.formatMessage({
                id: component_strings.alt2,
                defaultMessage: component_strings.alt2,
                description: "",
              })}
            />
            <p>
              <FormattedMessage
                id={component_strings.description2}
                defaultMessage={component_strings.description2}
                description=""
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export const Ideal57 = injectIntl(Ideal);
